var plugin_default = {
  "alignLeft": "Yae1T",
  "textWrapNowrap": "-n-K4",
  "alignRight": "_2m6KF",
  "alignCenter": "reJem",
  "sizeFullWidth": "_0YY3x",
  "renderedInTable": "dFOHq",
  "sizeOriginal": "KiWr6",
  "sizeContent": "xcQgO",
  "sizeSmall": "eAjls",
  "sizeSmallCenter": "_5UKJE",
  "flex": "UBQ1t",
  "atomic": "zvzWw",
  "embed": "EVlkE",
  "horizontalScrollbar": "_7FQ2R",
  "pluginContainerMobile": "jqrA7"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
